export default "__VITE_ASSET__773a40f6__"